// The condition grades an operator can set on a quote item: the stored value and the
// label shown. One list for the item's condition editor and the Add-item dialog.
export const ITEM_CONDITION_OPTIONS = [
    { value: 'Mint', label: 'Like New' },
    { value: 'Excellent', label: 'Excellent' },
    { value: 'Very Good', label: 'Very Good' },
    { value: 'Good', label: 'Good' },
    { value: 'Fair', label: 'Fair' },
    { value: 'Broken', label: 'Spares or Repair' },
];
